var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultora-de-precios"},[_c('logo-empresa'),_c('buscador')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }